import MessageBox from 'components/MessageBox/MessageBox.f';

export default MessageBox;
